import { Reference, Property, Name, Output, Text } from '@components/Reference';
import { Spacer } from '@cleartrip/bento/lib';
import Sandbox from '@components/Sandbox';
import * as React from 'react';
export default {
  Reference,
  Property,
  Name,
  Output,
  Text,
  Spacer,
  Sandbox,
  React
};